import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Accounts'

export const AdministrationAccountEP : EndPointConfig[] =[

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetAccounts"),  

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("GetUserAccounts"),  
        
        new EndPointConfig()
        .setMethod("POST")
        .setController(controller)
        .setActionName("EditAccount"),

        new EndPointConfig()
        .setMethod("DELETE")
        .setController(controller)
        .setActionName("DeleteAccount"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("ExportAccountsCommissions"),

        new EndPointConfig()
        .setMethod("GET")
        .setController(controller)
        .setActionName("ExportAccountUsersCommissions"),
]